// components/invisalign/PatientTestimonials.tsx
"use client";

import React from "react";
import Image from "next/image";

interface Testimonial {
  quote: string;
  author: string;
}

const PatientTestimonials: React.FC = () => {
  const testimonials: Testimonial[] = [
    {
      quote: '"I decided to do Invisalign with Dr. Khaimov , and I absolutely love this place! Almira and everyone else is super friendly and professional. As someone who has spent a lot of time at the dentist, it’s so important to me to understand what’s going on and feel supported throughout the process. I’m really glad I’m not being rushed, and I know I’ll have support every step of the way!"',
      author: "Sandra V."
    },
    {
      quote: '"AMAZING! So when I walked in it was like a luxury dental office, I met with the front desk first I discussed how I wanted my teeth more straight, to feel confident and everything. She said no problwm, they took me today to speak about invsaalign. When I tell you, the best payment treatment plan, everyone in there super friendly, super respectful. They took impressions of my teeth, showed me the payment plan, and how invsaalign worked. I really love this office fantastic!!! Thank you Smile4me!"',
      author: "Arielle J."
    },
    {
      quote: "“Dr. Iosif is truly an exceptional dentist. His professionalism, attention to detail, and genuine care for his patients make every visit comfortable and reassuring. You can immediately feel that you’re in safe hands. Highly recommended for anyone looking for top-quality dental care!”",
      author: "Mohamed A."
    }
  ];

  return (
    <section className="w-full py-10 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 space-y-6">
        <h2 className="text-4xl font-semibold text-center text-gray-800 after:content-[''] after:block after:w-[440px] after:h-[3px] after:mx-auto after:mt-2 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]">
          What Astoria Patients Say About Their Invisalign Results
        </h2>

        {/* Patient Image */}
        <div className="m-auto relative w-[275px] h-[213px] rounded-lg overflow-hidden mb-10">
          <Image
            src="/images/Smiling-woman-in-white-dress-with-black-chevron-pattern-walking-outside-holding-phone-after-Invisalign-treatment.webp"
            alt="Smiling woman in white dress with black chevron pattern walking outside holding phone after Invisalign treatment"
            fill
            className="object-cover"
          />
        </div>

        <p className="text-lg leading-relaxed text-gray-700">
          Patient feedback is one of the clearest signals for anyone comparing
          Invisalign providers in Astoria. Patients who&apos;ve completed Invisalign
          treatment at Smile4Me often mention the same things: clear
          communication, a comfortable office, and support at every stage.
        </p>

        {/* Testimonials */}
        <div className="space-y-6 mt-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg border-l-4 border-[#AE7D2F]">
              <blockquote className="text-lg text-gray-700 mb-4">
                {testimonial.quote}
              </blockquote>
              <cite className="text-gray-600 font-medium">
                — {testimonial.author}
              </cite>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PatientTestimonials;
